import { render, staticRenderFns } from "./username-change-request.vue?vue&type=template&id=11820a46&"
import script from "./username-change-request.vue?vue&type=script&lang=js&"
export * from "./username-change-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports